import { pattern, required, schema, SchemaPathTree } from '@angular/forms/signals';
import { VALIDATION_PATTERNS } from '@dss-libs/shared/type/common-types';

export const emailSchema = schema((emailKey: SchemaPathTree<string>) => {
  required(emailKey, { message: 'VALIDATION_MESSAGES.REQUIRED' });
  pattern(emailKey, VALIDATION_PATTERNS.email, { message: 'VALIDATION_MESSAGES.EMAIL_INVALID' });
});
